import React from 'react';

import './clients.scss';

import Gold from '../../assets/images/gold_badge.png';
import Phone from '../../assets/images/app_screen_1.png';

const Clients = () => {
    return (
        <section className="clients" id="clients">
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <h2 className="g-h2" data-aos="fade-up">Dla kogo jest<br/>MukoApp?</h2>
                        <p className="g-desc" data-aos="fade-up" data-aos-delay="150">Stworzyliśmy MukoApp z&nbsp;myślą o pacjentach i&nbsp;rodzicach osób chorych na mukowiscydozę. Mamy nadzieję, że stanie się ona przydatnym i&nbsp;motywującym narzędziem w&nbsp;walce o lepsze zdrowie i&nbsp;samopoczucie.</p>
                    </div>
                    <div className="col-6">
                        <img src={Gold} alt="Numer 1" className="clients__gold" data-aos="fade-right" data-aos-delay="150" />
                        <img src={Phone} alt="Aplikacja MukoApp" className="clients__phone" data-aos="fade-left" data-aos-delay="250" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Clients;